"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AppLayout_1 = __importDefault(require("@/Layouts/AppLayout"));
var react_i18next_1 = require("react-i18next");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Tab_1 = __importDefault(require("@/Components/common/Tab"));
var InviteMember_1 = __importDefault(require("./InviteMember"));
var invitedEmailsList_1 = __importDefault(require("./invitedEmailsList"));
var inertia_1 = require("@inertiajs/inertia");
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var MembersList_module_css_1 = __importDefault(require("./MembersList.module.css"));
function InvitedEmails() {
    var route = (0, useRoute_1.default)();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, q_play_components_1.useModal)(), isShown = _a.isShown, toggle = _a.toggle;
    var _b = (0, react_1.useState)(0), refreshKey = _b[0], setRefreshKey = _b[1];
    var refreshInvitationList = function () {
        setRefreshKey(function (prevKey) { return prevKey + 1; });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AppLayout_1.default, { title: "Users & Teams", renderHeader: function () { return (react_1.default.createElement("h2", { className: "header" }, t("Users & Teams"))); } },
            react_1.default.createElement("div", { className: MembersList_module_css_1.default.tabsContainer },
                react_1.default.createElement("div", { className: MembersList_module_css_1.default.topButtonsContainer },
                    react_1.default.createElement(q_play_components_1.Button, { text: t("Invite member"), onClick: toggle, className: MembersList_module_css_1.default.inviteMemberButton }),
                    react_1.default.createElement(Tab_1.default, { value: "users", onClick: function () { return inertia_1.Inertia.visit(route("team.users")); }, text: t("Users"), active: false, className: "me-4", variant: "primary" }),
                    react_1.default.createElement(Tab_1.default, { value: "invitedEmails", text: t("Invited emails"), active: true, variant: "secondary" }),
                    react_1.default.createElement(Tab_1.default, { value: "teams", text: t("Teams"), active: false, onClick: function () { return inertia_1.Inertia.visit(route("team.list")); }, className: "ms-4", variant: "primary" })),
                react_1.default.createElement(invitedEmailsList_1.default, { key: refreshKey })),
            react_1.default.createElement(InviteMember_1.default, { modal: { isShown: isShown, toggle: toggle }, onSuccess: refreshInvitationList }))));
}
exports.default = InvitedEmails;
